import { getElementXPath } from '@opentelemetry/sdk-trace-web';
import { InstrumentationBase } from '@opentelemetry/instrumentation';
import { onCLS, onFID, onINP, onLCP } from 'web-vitals';
import * as api from '@opentelemetry/api';

const PERFORMANCE_NAME_MAP = {
    performance: 'performance',
    CLS: 'performanceCLS',
    FID: 'performanceFID',
    INP: 'performanceINP',
    LCP: 'performanceLCP',
};
const VIEW_TIME_SPENT = 'ums.rum.view.time_spent';
const CLS = 'ums.rum.cls';
const FID = 'ums.rum.fid';
const INP = 'ums.rum.inp';
const LCP = 'ums.rum.lcp';
const LCPTarget = 'ums.rum.lcp.target';
const FIDTarget = 'ums.rum.fid.target';
const INPTarget = 'ums.rum.inp.target';

class PerformanceInstrumentation extends InstrumentationBase {
    constructor(config) {
        super('@heytap/cloud-observation-instrumentation-performance', "2.1.1", config || {});
    }
    init() { }
    _startSpan(name) {
        return api.context.with(api.ROOT_CONTEXT, () => {
            const span = this.tracer.startSpan(name);
            return span;
        });
    }
    _onLcp(metric) {
        const entry = metric.entries.find(entry => !!entry.element);
        const span = this._startSpan(PERFORMANCE_NAME_MAP.LCP);
        span.setAttribute(LCP, metric.value);
        if (entry)
            span.setAttribute(LCPTarget, getElementXPath(entry.element, true));
        span.end();
    }
    _onINP(metric) {
        const entry = metric.entries.find(entry => !!entry.target);
        const span = this._startSpan(PERFORMANCE_NAME_MAP.INP);
        span.setAttribute(INP, metric.value);
        if (entry)
            span.setAttribute(INPTarget, getElementXPath(entry.target, true));
        span.end();
    }
    _onFID(metric) {
        const entry = metric.entries.find(entry => !!entry.target);
        const span = this._startSpan(PERFORMANCE_NAME_MAP.FID);
        span.setAttribute(FID, metric.value);
        if (entry)
            span.setAttribute(FIDTarget, getElementXPath(entry.target, true));
        span.end();
    }
    _onCLS(metric) {
        const span = this._startSpan(PERFORMANCE_NAME_MAP.CLS);
        span.setAttribute(CLS, metric.value);
        span.end();
    }
    _initPerformance() {
        onCLS(metric => this._onCLS(metric));
        onFID(metric => this._onFID(metric));
        onINP(metric => this._onINP(metric));
        onLCP(metric => this._onLcp(metric));
    }
    enable() {
        this._initPerformance();
    }
    disable() { }
}

export { CLS, FID, FIDTarget, INP, INPTarget, LCP, LCPTarget, PERFORMANCE_NAME_MAP, PerformanceInstrumentation, VIEW_TIME_SPENT };
